export * from './productMap';

export const MEMBERSHIP_PRODUCT_API_STAGING =
  'https://www.staging.ultrahuman.com/subscription_checkout';

export const MEMBERSHIP_PRODUCT_API_PROD =
  'https://api.ultrahuman.com/subscription_checkout';
